<template>
  <v-app id="item">
    <v-content>
      <router-view></router-view>
    </v-content>
    
  </v-app>
</template>

<script> 
import axios from 'axios'
export default {
  name: 'App',
  components: {
  },
  created: function () {
    axios.interceptors.response.use(null, error => {
      if (error.response.status === 401) {
        this.$store.dispatch("AUTH_LOGOUT")
        .then(()=>{
          window.localStorage.removeItem("vuex")
          this.$router.push('/login');
        })
        .catch(()=>{
          this.$router.push('/login');
        })
      }
      else if(error.response.status === 403){
        this.$store.dispatch("AUTH_LOGOUT")
        .then(()=>{
          window.localStorage.removeItem("vuex")
          this.$router.push('/login');
        })
        .catch(()=>{
          this.$router.push('/login');
        })
      }

      return Promise.reject(error);
    });
    },
  methods:{
  }
};
</script>
<style>
  *{
    font-family: 'Work Sans';
  }
  #item{
    min-height:100vh;
    
  }
  .text-color{
    color:#48c074;
    color:#033953;
    color:#ffb34b;
  }
  
</style>